export default function CookingIllustration() {
  return (
    <svg
      className="menu-cooking"
      viewBox="0 0 240 180"
      fill="none"
      stroke="var(--app-ink)"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <g stroke="var(--app-muted)" strokeWidth="2.5">
        <path className="menu-cooking__steam" d="M94 78q-9-10 0-20t0-20" />
        <path className="menu-cooking__steam menu-cooking__steam--middle" d="M120 70q-9-10 0-20t0-20" />
        <path className="menu-cooking__steam menu-cooking__steam--last" d="M146 78q-9-10 0-20t0-20" />
      </g>
      <path d="M68 104H56a8 8 0 0 0 0 16h14m102-16h12a8 8 0 0 1 0 16h-14" />
      <path d="M68 96h104l-6 46a16 16 0 0 1-16 14H90a16 16 0 0 1-16-14z" fill="var(--app-yellow)" />
      <path d="M65 96h110M84 111l3 24" />
      <path d="M88 166h64" stroke="var(--app-line)" />
    </svg>
  );
}
